/**
 * News — a three-card grid of the latest financial/corporate stories. Ported
 * from the `.news` block (per-card navy → mid → light-blue accent ramp lives in
 * the SCSS).
 */

import AgntTextIcon from 'components/agnt-inc/agnt-text-icon';

import styles from './news.module.scss';

import type { NewsCard, NewsSection as NewsSectionContent } from '../content';

interface NewsProps {
  content: NewsSectionContent;
  cards: NewsCard[];
}

export default function News({ content, cards }: NewsProps) {
  return (
    <section className={styles.news}>
      <div className={styles.container}>
        <div className={styles.head} data-reveal>
          <div>
            <div className={styles.eyebrow}>{content.eyebrow}</div>
            <h2 className={styles.heading}>{content.heading}</h2>
          </div>
          <AgntTextIcon href={content.viewAll.href} label={content.viewAll.label} />
        </div>
        <div className={styles.grid}>
          {cards.map(card => (
            <a key={card.href} className={styles.card} href={card.href} data-reveal>
              <div className={styles.cardBody}>
                <div className={styles.date}>{card.date}</div>
                <div className={styles.title}>{card.title}</div>
                <div className={styles.excerpt}>{card.excerpt}</div>
                <div className={styles.readMore}>
                  Read more <span className={styles.arrow} aria-hidden="true">→</span>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
